import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { auth } from '@shared/api/services' ;
import { getTimezone } from '@utils/lib/getTimezone';
import { getUtmData } from '@utils/lib/getUtmData';
import { Register } from '@widgets/auth/ui/register/register';
import {
	clearStudentOnboardingPrefillSearch,
	persistStudentOnboardingPrefillSearch,
} from '@pages/student/onboarding/lib/student-onboarding-prefill';

export const RegisterPage = ({role = 'student'}) => {
	const { referral } = useParams();
	const navigate = useNavigate()
	const searchParams = new URLSearchParams(window.location.search)
	const phone = searchParams.get('phone')
	const name = searchParams.get('name')
	const email = searchParams.get('email')
	const invite_token = searchParams.get('invite_token')
	const teacher_id = searchParams.get('teacher_id')

	const [error, setError] = useState('')
	

	const methods = useForm({defaultValues: {
			phone: phone || '',
			email: email || '',
			password: '',
			name: name || '',
		},	
		mode: 'onTouched'
	})

	const {formState} = methods
	
  const handleSubmit = methods.handleSubmit(data => {
		const utmData = getUtmData();

		const payload = {
			phone: data.phone,
			email: data.email,
			password: data.password,
			name: data.name,
			role,
			timezone: getTimezone(),
			invite_token,
			referral,
			...(utmData && { meta: utmData }),
		}

		if (role === 'teacher') {
			clearStudentOnboardingPrefillSearch()

			auth.register(payload).then(() => {
				navigate('/waiting-confirm-teacher')
			}).catch((response) => {
				if(response?.response){
					setError(response.response)
				}else{
					setError({localMessage: 'Ошибка сети'})
				}
			})

			return
		}

		if (role === 'student') {
			persistStudentOnboardingPrefillSearch(window.location.search)
		} else {
			clearStudentOnboardingPrefillSearch()
		}
		
		auth.register(payload, teacher_id).catch((response) => {
			if(response?.response){
				setError(response.response)
			}else{
				setError({localMessage: 'Ошибка сети'})
			}
		})
  })

	return <Register {...{handleSubmit, referral, error, methods, formState, role}}/>
}
